export var EmailTargetOption; // TODO: Rename to MediaJobStatus

(function (EmailTargetOption) {
  EmailTargetOption["LEADS"] = "leads";
  EmailTargetOption["CUSTOMERS"] = "customers";
  EmailTargetOption["SUBSCRIBERS"] = "subscribers";
  EmailTargetOption["NEW_LEADS_ONGOING"] = "newLeadsOngoing";
})(EmailTargetOption || (EmailTargetOption = {}));

export var JobStatus; // Pages ---------------------------
// Analytics

(function (JobStatus) {
  JobStatus["SUBMITTED"] = "SUBMITTED";
  JobStatus["PROGRESSING"] = "PROGRESSING";
  JobStatus["STATUS_UPDATE"] = "STATUS_UPDATE";
  JobStatus["INPUT_INFORMATION"] = "INPUT_INFORMATION";
  JobStatus["COMPLETE"] = "COMPLETE";
  JobStatus["ERROR"] = "ERROR";
})(JobStatus || (JobStatus = {}));

export var EventTypes;

(function (EventTypes) {
  EventTypes["LEAD_SIGNUP"] = "lead_signup";
  EventTypes["EMAIL_OPEN"] = "email_open";
  EventTypes["EMAIL_CLICK"] = "email_click";
  EventTypes["VIEW_POST"] = "view_post";
  EventTypes["EMAIL_UNSUBSCRIBE"] = "email_unsubscribe";
  EventTypes["SURVEY_ANSWER"] = "survey_answer";
  EventTypes["CUSTOMER_SIGNUP"] = "customer_signup";
  EventTypes["SUBSCRIBER_SIGNUP"] = "subscriber_signup";
  EventTypes["WRITE_POST"] = "write_post";
  EventTypes["CREATE_EMAIL_CAMPAIGN"] = "create_email_campaign";
  EventTypes["SCHEDULE_SESSION"] = "schedule_session";
  EventTypes["SESSION_BOOKING"] = "session_booking";
  EventTypes["REFERRAL"] = "referral";
  EventTypes["REFERRAL_PROVIDER"] = "referral_provider";
  EventTypes["SCHEDULE_CANCELLATION"] = "schedule_cancellation";
  EventTypes["CANCEL_SUBSCRIPTION"] = "cancel_subscription";
  EventTypes["CANCEL_BOOKING"] = "cancel_booking";
  EventTypes["PROFILE_VIEW"] = "profile_view";
  EventTypes["JOINED_WAITLIST"] = "joined_waitlist";
  EventTypes["COMPLETED_WAITLIST_SURVEY"] = "completed_waitlist_survey";
  EventTypes["SUBSCRIPTION_UPGRADED"] = "subscription_upgraded";
  EventTypes["SUBSCRIPTION_DOWNGRADED"] = "subscription_downgraded";
  EventTypes["REVIEW"] = "review";
})(EventTypes || (EventTypes = {}));

export var ResourceTypes; // Payments

(function (ResourceTypes) {
  ResourceTypes["MILESTONE"] = "Milestone";
  ResourceTypes["METRIC"] = "Metric";
  ResourceTypes["TOPIC"] = "Topic";
})(ResourceTypes || (ResourceTypes = {}));

// Survey
// Plan Survey Fixed Question Identifiers
export var IPlanSurveyQuestionIdentifiers;

(function (IPlanSurveyQuestionIdentifiers) {
  IPlanSurveyQuestionIdentifiers["OVERALL_VALUE"] = "overall_value";
  IPlanSurveyQuestionIdentifiers["PRICE_TOO_LOW"] = "price_too_low";
  IPlanSurveyQuestionIdentifiers["PRICE_BARGAIN"] = "price_bargain";
  IPlanSurveyQuestionIdentifiers["PRICE_EXPENSIVE"] = "price_expensive";
  IPlanSurveyQuestionIdentifiers["PRICE_TOO_HIGH"] = "price_too_high";
  IPlanSurveyQuestionIdentifiers["FEATURES_TO_INCLUDE"] = "features_to_include";
  IPlanSurveyQuestionIdentifiers["USELESS_FEATURES"] = "useless_features";
  IPlanSurveyQuestionIdentifiers["USELESS_EXPLAIN"] = "useless_explain";
})(IPlanSurveyQuestionIdentifiers || (IPlanSurveyQuestionIdentifiers = {}));